import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';


const NoBackupsBlock: FunctionComponent = () => {
  const { t: translate } = useTranslation();

  return (
    <div className="no-backup">
      <div className="subtitle">{translate('views.platform_pages.backups_soon')}</div>
    </div>
  );
};

export default (NoBackupsBlock);
